import { VStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import React from 'react';
import { useTheme } from '@springbig/shared';

export type GenericSpecialProps = {
  name: string;
};

export const GenericSpecial = ({ name }: GenericSpecialProps) => {

    const {
        radius_md,
        card,
        card_text,
    } = useTheme();

    return (
        <VStack
            w={'100%'}
            h={'120px'}
            p={4}
            alignItems={'center'}
            justifyContent={'center'}
            bg={card}
            rounded={radius_md}
        >
            <Caption
                position={'absolute'}
                zIndex={-1}
                top={0}
                left={0}
                bottom={0}
                right={0}
                fontSize={36}
                fontWeight={'700'}
                color={card_text}
                textAlign={'center'}
            >
                { name.toUpperCase() }
            </Caption>
            <Caption
                fontSize={24}
                fontWeight={'700'}
                color={card_text}
            >
                { name.toUpperCase() }
            </Caption>
        </VStack>
    );
};
